import HorizontalLayout from '../../../components/HorizontalLayout';
import DataBreachIncident from '../pages/employee/data-breach-incident';
import DSRRequest from '../pages/employee/dsr';
import EmployeeMyTasks from '../pages/employee/my-tasks';
import EmployeeMyTaskDetails from '../pages/employee/my-tasks/details'; 
import ReportDetails from '../pages/report-details';
import UserManual from '../pages/UserManual';
import MyReports from '../pages/employee/my-reports';
import InstallDeviceAgent from "../pages/common/device-agent";

const dataProtectionRoutes = [
	{
		path: '/employee/data-protection/user_manual',
		component: UserManual,
		layout: HorizontalLayout,
		type: 'employee',
		modules: ["gd"]
	},
    {
        path: '/employee/data-protection/data-subject-request/details/:id',
        component: ReportDetails,
        layout: HorizontalLayout,
        type: 'employee',
        modules: ["gd"]
    },
    {
        path: '/employee/data-protection/incident-register/details/:id',
        component: ReportDetails,
        layout: HorizontalLayout,
        type: 'employee',
        modules: ["gd"]
    },
	{
		path: '/employee/data-protection/reports',
		component: MyReports,
		layout: HorizontalLayout,
		type: 'employee',
		modules: ["gd"],
		title: 'List Reports | SIP',
	},
    {
        path: '/employee/data-protection/tasks/:id',
        component: EmployeeMyTaskDetails,
        layout: HorizontalLayout,
        type: 'employee',
        modules: ["gd"],
    },
    {
        path: '/employee/data-protection/tasks',
        component: EmployeeMyTasks,
        layout: HorizontalLayout,
        type: 'employee',
        modules: ["gd"],
    },
    {
		path: '/employee/data-protection/data-breach-incident',
		component: DataBreachIncident,
		layout: HorizontalLayout,
		type: 'employee',
		modules: ["gd"],
		title: 'Data Breach Incident Request | SIP',
	},
	{
		path			:	'/employee/data-protection/data-subject-request',
		component		:	DSRRequest,
		layout			:	HorizontalLayout,
		type			:	'employee',
		modules         :   ["gd"],
		title			:	'DSR Request | SIP',
	},
    {
		path			:	'/employee/data-protection/device-agent',
		component		:	InstallDeviceAgent,
		layout			:	HorizontalLayout,
		type			:	'employee',
		modules         :   ["gd"],
		title			:	'Install Windows Device Agent | SIP',
	}
];

export default dataProtectionRoutes;
